/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import classnames from 'classnames';

export interface RequiredStarProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  isColor?: boolean;
}

const RequiredStar: React.FunctionComponent<RequiredStarProps> = ({
  className,
  isColor = false,
  ...props
}) => (
  <abbr
    title='required'
    className={classnames({ input__required: isColor }, className)}
    {...props}
  >
    *
  </abbr>
);

export default RequiredStar;
